<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      Court Documents
    </div>
  </div>

  <div class="row indentContent">
    <div class="col-md-12">
      <ul>
        <li>
          <a href="../../../assets/docs/Claim Form.pdf"
             target="_blank" style="color:#006cDb">
            Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Long Form Notice.pdf"
             target="_blank" style="color:#006cDb">
            Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Flo Flurry Goodle SF Notice.pdf"
             target="_blank" style="color:#006cDb">
            Flo Flurry Google SF Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Order RE Preliminary Approval RE Google LLC and FLO Health, Inc_.pdf"
             target="_blank" style="color:#006cDb">
            Order RE Preliminary Approval RE Google LLC and FLO Health, Inc.
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Order Re Class Certification.pdf"
             target="_blank" style="color:#006cDb">
            Order Re Class Certification
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Consolidated Complaint.pdf"
             target="_blank" style="color:#006cDb">
            Consolidated Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Flurry Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Flurry Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Google Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Google Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Flo Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Flo Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 - Plaintiffs Motion for Final Approval of Class Action Settlements.pdf"
             target="_blank" style="color:#006cDb">
            Plaintiffs' Notice of Motion and Motion for Final Approval of Class Settlements with Defendants Flurry LLC, Google LLC and Flo Health, Inc.
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 MOTION for Attorney Fees and Expenses and Plaintiffs Application for Service Awards.pdf"
             target="_blank" style="color:#006cDb">
            Class Counsel's Notice of Motion and Motion for Award of Attorneys' Fees and Expenses, and Plaintiffs' Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 - Declaration of Heather  Littrell of A.B. Data In Support of Motions.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of Heather Littrell of A.B. Data in Support of Plaintiffs' Motion for Final Approval of Class Settlements with Defendants Flurry LLc, Google LLC, and Flo Health, Inc.
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 - Joint Declaration In Support of Motion for Final Approval.pdf"
             target="_blank" style="color:#006cDb">
            Joint Declaration of Christian Levis, Carol C. Villegas, and Diana J. Zinser in Support of Plaintiffs' Motion for Final Approval of Class Settlements with Defendants Flurry LLC, Google LLC and Flo Health, Inc. and Class Counsel's Motion For Award of Attorneys' Fees and Expenses, and Plaintiffs' Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20- Fee and Expense Declarations.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of Christian Levis in Support of Class Counsel's Motion for Award of Attorneys' Fees adn Expenses, and Plaintiffs' Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Reply in Support of Plaintiffs’ Motion for Final Approval of Class Settlements.pdf"
             target="_blank" style="color:#006cDb">
            Reply in Support of Plaintiffs’ Motion for Final Approval of Class Settlements with Defendants Flurry LLC, Google LLC, and Flo Health, Inc. and Class Counsel’s Motion for Award of Attorneys’ Fees and Expenses, and Plaintiffs’ Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Declaration of Heather Littrell of A.B. Data on Implementation of Notice Plan.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of Heather Littrell of A.B. Data on Implementation of Notice Plan
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order fees, Expenses, Service Award.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order fees, Expenses, Service Award
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flo Final Approval Order.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flo Final Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flo Final Judgment.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flo Final Judgment
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flurry Final Approval Order.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flurry Final Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flurry Final Judgment.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flurry Final Judgment
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Google Final Approval Order.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Google Final Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Google Final Judgment.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Google Final Judgment
          </a>
        </li>
      </ul> 
    </div>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      Court Documents
    </div>
  </div>

  <div class="row indentContent">
    <div class="col-md-12">
      <ul>
        <li>
          <a href="../../../assets/docs/Claim Form.pdf"
             target="_blank" style="color:#006cDb">
            Claim Form
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Long Form Notice.pdf"
             target="_blank" style="color:#006cDb">
            Long Form Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Flo Flurry Goodle SF Notice.pdf"
             target="_blank" style="color:#006cDb">
            Flo Flurry Google SF Notice
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Order RE Preliminary Approval RE Google LLC and FLO Health, Inc_.pdf"
             target="_blank" style="color:#006cDb">
            Order RE Preliminary Approval RE Google LLC and FLO Health, Inc.
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Order Re Class Certification.pdf"
             target="_blank" style="color:#006cDb">
            Order Re Class Certification
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Consolidated Complaint.pdf"
             target="_blank" style="color:#006cDb">
            Consolidated Complaint
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Flurry Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Flurry Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Google Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Google Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/Flo Settlement Agreement.pdf"
             target="_blank" style="color:#006cDb">
            Flo Settlement Agreement
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 - Plaintiffs Motion for Final Approval of Class Action Settlements.pdf"
             target="_blank" style="color:#006cDb">
            Plaintiffs' Notice of Motion and Motion for Final Approval of Class Settlements with Defendants Flurry LLC, Google LLC and Flo Health, Inc.
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 MOTION for Attorney Fees and Expenses and Plaintiffs Application for Service Awards.pdf"
             target="_blank" style="color:#006cDb">
            Class Counsel's Notice of Motion and Motion for Award of Attorneys' Fees and Expenses, and Plaintiffs' Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 - Declaration of Heather  Littrell of A.B. Data In Support of Motions.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of Heather Littrell of A.B. Data in Support of Plaintiffs' Motion for Final Approval of Class Settlements with Defendants Flurry LLc, Google LLC, and Flo Health, Inc.
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20 - Joint Declaration In Support of Motion for Final Approval.pdf"
             target="_blank" style="color:#006cDb">
            Joint Declaration of Christian Levis, Carol C. Villegas, and Diana J. Zinser in Support of Plaintiffs' Motion for Final Approval of Class Settlements with Defendants Flurry LLC, Google LLC and Flo Health, Inc. and Class Counsel's Motion For Award of Attorneys' Fees and Expenses, and Plaintiffs' Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/2026-08-20- Fee and Expense Declarations.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of Christian Levis in Support of Class Counsel's Motion for Award of Attorneys' Fees adn Expenses, and Plaintiffs' Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Reply in Support of Plaintiffs’ Motion for Final Approval of Class Settlements.pdf"
             target="_blank" style="color:#006cDb">
            Reply in Support of Plaintiffs’ Motion for Final Approval of Class Settlements with Defendants Flurry LLC, Google LLC, and Flo Health, Inc. and Class Counsel’s Motion for Award of Attorneys’ Fees and Expenses, and Plaintiffs’ Application for Service Awards
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Declaration of Heather Littrell of A.B. Data on Implementation of Notice Plan.pdf"
             target="_blank" style="color:#006cDb">
            Declaration of Heather Littrell of A.B. Data on Implementation of Notice Plan
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order fees, Expenses, Service Award.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order fees, Expenses, Service Award
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flo Final Approval Order.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flo Final Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flo Final Judgment.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flo Final Judgment
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flurry Final Approval Order.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flurry Final Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Flurry Final Judgment.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Flurry Final Judgment
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Google Final Approval Order.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Google Final Approval Order
          </a>
        </li>
        <li>
          <a href="../../../assets/docs/10.23.26/Proposed Order Google Final Judgment.pdf"
             target="_blank" style="color:#006cDb">
            Proposed Order Google Final Judgment
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>






